@if (loaderIcon | async) {
  <app-loader></app-loader>
}

<div class="modal fade" bsModal #PaymentDetailsModal="bs-modal" [config]="modalConfig" id="PaymentDetailsModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal_80 modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Payment : Unit # {{UnitNo}}</h5>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal" (click)="closemakePay()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="d-flex flex-row">
          <div class="p-2">
            <label># of Additional Prepayment Period@if (noPeriodMpaymentField) {
              <span class="required"
              >*</span>
            }</label>
            <input class="form-control" type="text" [(ngModel)]="prePaymentPeriod" (keypress)="numberOnly($event)"
              (paste)="onPaste($event)" (keyup)="subjectPrePaymentPeriod.next($event)" #noField="ngModel"
              [disabled]="LeaseId == 327 || disableLeaseStatus()">
              @if (noPeriodMpaymentField && noField.touched) {
                <div class="alert alert-danger">
                  <span>
                    # of Additional Prepayment Period is required
                  </span>
                </div>
                }<br>
              </div>
              <div class="p-2">
                <label>Paid Thru Date</label>
                <input class="form-control" type="text" value="{{mpPTD | date :'MM/dd/yyyy'}}" readonly>
              </div>
              @if (isUnitDelinquent) {
              <div class="p-2" style="margin-top: 25px; margin-left: 10px;">
                <label class="pure-material-checkbox">
                  <input class="custom-control-input" type="checkbox" [(ngModel)]="payTillLastPeriod" (click)="checkPayTillLastPeriod($event)">
                  <span class="form-check-label ms-2 fw-bold">
                    Pay till {{ lastPeriodToDate | date:'MM/dd/yyyy' }}
                  </span>
                </label>
              </div>
              }
            </div>
            <div class="payment_modal_out">
              @if (isCustomerDetailsLoaded | async) {
                <div class="paylemt_details_box mt-3">
                  <div class="list_view">
                    <div class="list_view_row">
                      <div class="contSection">
                        <label>Billed Thru Date</label>
                        <div>{{billedThruDate | date: 'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="btnSection"></div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label>Deposit</label>
                        <div>{{customerDuesDetails?.TotalDepositDue | currency}}</div>
                      </div>
                      <div class="btnSection"></div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label>Rent</label>
                        <div>{{customerDuesDetails?.TotalRentDue | currency}}</div>
                      </div>
                      <div class="btnSection"></div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label class="text-primary">Pricing / Promotions</label>
                        @if (!labelPricingPromotionAppliedPD) {
                          <div>{{customerDuesDetails?.TotalDiscount | currency}}</div>
                        }
                        @if (labelPricingPromotionAppliedPD) {
                          <div>{{0 | currency}}</div>
                        }
                      </div>
                      <div class="btnSection">
                        <button type="submit" class="btn btn-primary" (click)="editPricingPromotions()">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label class="text-primary">Fees</label>
                        <div>{{customerDuesDetails?.TotalFeesDue | currency}}</div>
                      </div>
                      <div class="btnSection">
                        <button type="submit" class="btn btn-primary" (click)="editFees()" permissionHandler [functId]="95"
                          [elementType]="eNumElementTypes.BUTTON" [action]="eNumActionTypes.VIEW">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label class="text-primary">{{propertyProtectionLabel}}</label>
                        <div>{{customerDuesDetails?.TotalInsuranceDue | currency}}</div>
                      </div>
                      <div class="btnSection">
                        <button type="submit" class="btn btn-primary" (click)="editPropertyProtection()">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label>Late and Lien</label>
                        <div>{{customerDuesDetails?.TotalLateLienChargeDue | currency}}</div>
                      </div>
                      <div class="btnSection"></div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label>Merchandise</label>
                        <div>{{customerDuesDetails?.TotalMerchandiseDue | currency}}</div>
                      </div>
                      <div class="btnSection"></div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label>Tax</label>
                        <div>{{totalCustomerDuesTax | currency}}</div>
                      </div>
                      <div class="btnSection"></div>
                    </div>
                    <div class="list_view_row mt-3">
                      <div class="contSection">
                        <label class="text-primary">Allowances</label>
                        <div>{{totalAllowance | currency}}</div>
                      </div>
                      <div class="btnSection button_tooltip">
                        <button permissionHandler [functId]="94" [action]="eNumActionTypes.EDIT"
                          [elementType]="eNumElementTypes.BUTTON" type="submit" class="btn btn-primary"
                          (click)="editAllowances()" [disabled]="Allowancedisable()">
                          <i class="fa fa-pencil"></i>
                        </button>
                        @if (errorAllowanceCount) {
                          <div class="button_tooltip_modal">
                            @if (errorAllowanceCount) {
                              <p class="mb-0">This Rental has already been
                              given maximum number of Allowances Permissible</p>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="list_view mt-auto">
                    <div class="list_view_row mt-3">
                      <div class="contSection text-primary totalAmount">
                        <label>Total Amount Due</label>
                        <div>{{totalCustomerDues | currency}}</div>
                      </div>
                      <div class="btnSection">
                        <button type="submit" class="btn btn-primary" permissionHandler [functId]="368"
                          [action]="eNumActionTypes.EDIT" [elementType]="eNumElementTypes.BUTTON"
                          (click)="editPaymentDistribution()">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="payment_edit_box mt-3">

                <!-- Fees Section Start -->
                @if (feesSection) {
                  <div class="edit_container">
                    <h5 class="edit_container_title">Fees</h5>
                    <app-feesCharges [moduleType]='2' [FeesEditRight]="FeesEditRight" [MoveInDate]="MoveInDatePP" [TotalSquareFoot]="TotalSquareFoot"
                      [feesAndChargesDataGrid]="feesAndChargesDataGrid" [Rent]="Rent" [ProrateRent]="ProrateRent"
                      [dayEndFacilityDate]="FacilityDate" [manualFeesAndCharges]="manualFeesAndCharges" [effectiveDatesList]="effectiveDatesList"
                      [stopDatesList]="stopDatesList" [rentRaiseSettings]="rentRaiseSettings"
                      [LatestURCToDate]="LatestURCToDate" [NextBillingDate]="NextBillingDate"
                      (saveFeesAndChargesEmit)="FeesChargesChanges($event)" [PaidThroughDate]="PaidThroughDate">
                    </app-feesCharges>
                  </div>
                }
                <!-- Fees Section End // -->

                <!-- Property Protection Section Start -->
                @if (propertyProtectionSection) {
                  <div class="edit_container">
                    <h5 class="edit_container_title">{{propertyProtectionLabel}}</h5>
                    <app-property-protection [moduleType]='2'
                      [CustomerPropertyProtectionList]="CustomerPropertyProtectionList" [NextBillingDate]="NextBillingDate"
                      [facilityMoveInSettings]="facilityMoveInSettings" [effectiveDatesList]="effectiveDatesList"
                      (emitPropProtInit)="propertProtectionInit($event)" [selectedInsuranceId]='selectedInsuranceId'
                      [dayEndFacilityDate]="FacilityDate" [propertyProtectionLabel]="propertyProtectionLabel"
                      (emitPropertyProtectionObject)="propertyProtectionChanges($event)" [NextDayendDate]="NextDayendDate"
                      [MoveInDate]="MoveInDatePP"  [CurrentURCFromDate]="CurrentURCFromDate">
                    </app-property-protection>
                  </div>
                }
                <!-- Property Protection Section End // -->

                <!-- Pricing / Promotions Section Start -->
                @if (PricingPromotionsSection) {
                  <div class="edit_container float-start">
                    <h5 class="edit_container_title">Pricing / Promotions</h5>
                    <app-pricing-promotion [moduleType]="EModuleType.MakePayment" [moveInSettings]="facilityMoveInSettings"
                      [LatestURCToDatePlusOne]="LatestURCToDatePlusOne" (emitDiscountList)="SavePricingAndPromotions($event)"
                      [discountModalList]="customerDiscountList" [effectiveDatesList]="effectiveDatesList"
                      [stopDatesList]="stopDatesList" [paymentSetting]="paymentSettings">
                    </app-pricing-promotion>
                  </div>
                }
                <!-- Pricing / Promotions Section End // -->

                <!-- Allowance Section Start -->
                @if (AllowanceSection) {
                  <div class="edit_container">
                    <h5 class="edit_container_title">Allowance</h5>
                    <app-allowance-component [MandatoryFieldFormId]="171" [allowanceDataList]="allowanceDataList"
                      [facilityAllowanceItems]="facilityAllowanceItems" [miscellaneousSettings]="miscellaneousSettings"
                      (saveAllowanceEmit)="allowanceChange($event)" (saveAllowanceNotesEmit)="addAllowanceNotes($event)"
                      [allowanceNotes]="allowanceNotes" [selectedAllowanceItemId]="allowanceItemId">
                    </app-allowance-component>
                  </div>
                }
                <!-- Allowance Section End // -->

                @if (PaymentDistributionSection) {
                  <div class="edit_container">
                    <h5 class="edit_container_title">Payment Distribution</h5>
                    <div class="row">
                      <div class="col-md-7">
                        <div class="distribution_list d-flex align-items-center">
                          <label>Deposit</label>
                          <div class="distList-inputbox">
                            <input type="text" class="form-control form-control-sm text-end"
                              [ngModel]="depositPD | currency" (keypress)="numberOnly($event)"
                              (change)="depositPD = currencyInputChanged($event.target.value , 'depositPD')">
                              @if (depositPDIsEdit) {
                                <div class="alert alert-danger">
                                  <span>
                                    Deposit amount allocated is greater than due
                                  </span>
                                </div>
                              }
                            </div>
                            <span>{{depositPDlab | currency}}</span>
                          </div>
                          <div class="distribution_list d-flex align-items-center">
                            <label>Rent</label>
                            <div class="distList-inputbox">
                              <input type="text" class="form-control form-control-sm text-end" [ngModel]="rentPD | currency"
                                (keypress)="numberOnly($event)"
                                (change)="rentPD = currencyInputChanged($event.target.value, 'rentPD')">
                                @if (rentPDIsEdit) {
                                  <div class="alert alert-danger">
                                    <span>
                                      Rent amount allocated is greater than due
                                    </span>
                                  </div>
                                }
                              </div>
                              <span>{{rentPDlab | currency}}</span>
                            </div>
                            <div class="distribution_list d-flex align-items-center">
                              <label>Fees</label>
                              <div class="distList-inputbox">
                                <input type="text" class="form-control form-control-sm text-end" [ngModel]="feesPD | currency"
                                  (keypress)="numberOnly($event)"
                                  (change)="feesPD = currencyInputChanged($event.target.value, 'feesPD')">
                                  @if (feesPDIsEdit) {
                                    <div class="alert alert-danger">
                                      <span>
                                        Fees amount allocated is greater than due
                                      </span>
                                    </div>
                                  }
                                </div>
                                <span>{{feesPDlab | currency}}</span>
                              </div>
                              <div class="distribution_list d-flex align-items-center">
                                <label>{{propertyProtectionLabel}}</label>
                                <div class="distList-inputbox">
                                  <input type="text" class="form-control form-control-sm text-end"
                                    [ngModel]="propProtPD | currency" (keypress)="numberOnly($event)"
                                    (change)="propProtPD = currencyInputChanged($event.target.value, 'propProtPD')">
                                    @if (propProtPDIsEdit) {
                                      <div class="alert alert-danger">
                                        <span>
                                          {{propertyProtectionLabel}} amount allocated is greater than due
                                        </span>
                                      </div>
                                    }
                                  </div>
                                  <span>{{propProtPDlab | currency}}</span>
                                </div>
                                <div class="distribution_list d-flex align-items-center">
                                  <label>Merchandise</label>
                                  <div class="distList-inputbox">
                                    <input type="text" class="form-control form-control-sm text-end"
                                      [ngModel]="merchandisePD | currency" (keypress)="numberOnly($event)"
                                      (change)="merchandisePD = currencyInputChanged($event.target.value, 'merchandisePD')">
                                      @if (merchandisePDIsEdit) {
                                        <div class="alert alert-danger">
                                          <span>
                                            Merchandise amount allocated is greater than due
                                          </span>
                                        </div>
                                      }
                                    </div>
                                    <span>{{merchandisePDlab | currency}}</span>
                                  </div>
                                  <div class="distribution_list d-flex align-items-center">
                                    <label>Late & Lien charges</label>
                                    <div class="distList-inputbox">
                                      <input type="text" class="form-control form-control-sm text-end"
                                        [ngModel]="lateAndlienPD | currency" (keypress)="numberOnly($event)"
                                        (change)="lateAndlienPD = currencyInputChanged($event.target.value, 'lateAndlienPD')">
                                        @if (lateAndlienPDIsEdit) {
                                          <div class="alert alert-danger">
                                            <span>
                                              Late & Lien charges allocated is greater than due
                                            </span>
                                          </div>
                                        }
                                      </div>
                                      <span>{{lateAndlienPDlab | currency}}</span>
                                    </div>
                                    <div class="distribution_list_tot border-top d-flex align-items-center">
                                      <label>Total</label>
                                      <b>{{totalPaymentDist | currency}}</b>
                                      <span>{{tempPDTotalCustomerDues | currency}}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="row mx-0 mt-3">
                          <a href="#Payment_Breakdown" data-bs-toggle="modal" class="view_breakup">View Breakdown of Dues</a>
                        </div>
                        <div class="row mx-0 mt-3">
                          <label>Notes@if (notesMPaymentField) {
                            <span class="required">*</span>
                          }</label>
                          <textarea rows="5" class="form-control" [(ngModel)]="makePaymentNotes" #notesfield="ngModel"></textarea>
                          @if (notesMPaymentField && notesfield.touched) {
                            <div class="alert alert-danger">
                              <span>
                                Notes is required
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="modal-footer d-flex justify-content-between" style="margin: 0px 0px 18px 0px">
                        <div>
                          <div class="button_tooltip">
                            @if (partialPayReturn == true) {
                              <button type="button" class="btn btn-primary"
                                (click)="openPartialPayment()" data-bs-backdrop="static">
                                Partial Payment Return
                              </button>
                            }
                          </div>
                        </div>
                        <div class="d-inline-flex">
                          <div class="button_tooltip">
                            <button type="button" class="btn btn-outline-primary me-3 float-start" data-bs-dismiss="modal"
                              (click)="subjectSaveSAllowance.next($event)" permissionHandler [functId]="94"
                              [action]="eNumActionTypes.EDIT" [elementType]="eNumElementTypes.BUTTON"
                              [disabled]="totalAllowance == 0  || (this.totalAllowance != 0 && this.allowanceNotes ==='')|| checkFeesChargesDisable() || (this.allowanceError != 0) || errorAllowanceCount || checkFeesChargesNotesRequired() || errorPropertProtectionModel">
                              Save Allowance
                            </button>
                            @if (checkFeesChargesDisable() || (this.allowanceError != 0) || errorAllowanceCount || checkFeesChargesNotesRequired() || errorPropertProtectionModel) {
                              <div class="button_tooltip_modal"
                                >
                                @if (checkFeesChargesNotesRequired() && !checkFeesChargesDisable() && !errorAllowanceCount && allowanceError == 0) {
                                  <p class="mb-0"
                                    >
                                  Notes for stopped Fees is required!</p>
                                }
                                @if (checkFeesChargesDisable()) {
                                  <p class="mb-0">Error under Fees section!</p>
                                }
                                @if (!checkFeesChargesDisable() && errorAllowanceCount) {
                                  <p class="mb-0">This Rental has already been
                                  given maximum number of Allowances Permissible</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 1 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount cannot be greater than {{selectedAllowanceItemDetail.MaxValue}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 2 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount cannot be less than {{selectedAllowanceItemDetail.Value}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 3 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount should be equal to {{selectedAllowanceItemDetail.Value}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 0 && !errorAllowanceCount && errorPropertProtectionModel) {
                                  <p class="mb-0"
                                    >
                                  Property Protection fields are required!</p>
                                }
                                <i class="fa fa-caret-down butt_downIcon" aria-hidden="true"></i>
                              </div>
                            }
                          </div>
                          <div class="button_tooltip">
                            <button type="button" class="btn btn-outline-primary me-3 float-start" data-bs-dismiss="modal" permissionHandler
                              [functId]="74" [action]="eNumActionTypes.EDIT" [elementType]="eNumElementTypes.BUTTON"
                              (click)="makePayNow(1)"
                              [disabled]="disablePayNow() || checkFeesChargesDisable() || (this.allowanceError != 0) || checkFeesChargesNotesRequired() || errorPropertProtectionModel">
                              Pay Now
                            </button>
                            @if (checkFeesChargesDisable() || (this.allowanceError != 0)  || checkFeesChargesNotesRequired() || errorPropertProtectionModel) {
                              <div class="button_tooltip_modal"
                                >
                                @if (checkFeesChargesDisable()) {
                                  <p class="mb-0">Error under Fees section!</p>
                                }
                                @if (!checkFeesChargesDisable()) {
                                  <p class="mb-0">This Rental has already been
                                  given maximum number of Allowances Permissible</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 1 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount cannot be greater than {{selectedAllowanceItemDetail.MaxValue}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 2 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount cannot be less than {{selectedAllowanceItemDetail.Value}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 3 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount should be equal to {{selectedAllowanceItemDetail.Value}}</p>
                                }
                                @if (checkFeesChargesNotesRequired() && !checkFeesChargesDisable() && !errorAllowanceCount && allowanceError == 0) {
                                  <p class="mb-0"
                                    >
                                  Notes for stopped Fees is required!</p>
                                }
                                @if (!checkFeesChargesNotesRequired() && !checkFeesChargesDisable() && !errorAllowanceCount && allowanceError == 0 && errorPropertProtectionModel) {
                                  <p class="mb-0"
                                    >
                                  Property Protection fields are required!</p>
                                }
                                <i class="fa fa-caret-down butt_downIcon" aria-hidden="true"></i>
                              </div>
                            }
                          </div>
                          <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal" (click)="closemakePay()">
                            Cancel
                          </button>
                          <div class="button_tooltip">
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                              [disabled]="disableAddToCard() || checkFeesChargesDisable() || (this.allowanceError != 0)  || checkFeesChargesNotesRequired() || errorPropertProtectionModel"
                              (click)="addUnitToCart()" permissionHandler [functId]="74" [action]="eNumActionTypes.EDIT"
                              [elementType]="eNumElementTypes.BUTTON">
                              Add To Cart
                            </button>
                            @if (checkFeesChargesDisable() || (this.allowanceError != 0)  || checkFeesChargesNotesRequired() || errorPropertProtectionModel) {
                              <div class="button_tooltip_modal"
                                >
                                @if (checkFeesChargesDisable()) {
                                  <p class="mb-0">Error under Fees section!</p>
                                }
                                @if (!checkFeesChargesDisable()) {
                                  <p class="mb-0">This Rental has already been
                                  given maximum number of Allowances Permissible</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 1 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount cannot be greater than {{selectedAllowanceItemDetail.MaxValue}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 2 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount cannot be less than {{selectedAllowanceItemDetail.Value}}</p>
                                }
                                @if (!checkFeesChargesDisable() && allowanceError == 3 && !errorAllowanceCount) {
                                  <p class="mb-0">
                                  Allowance Amount should be equal to {{selectedAllowanceItemDetail.Value}}</p>
                                }
                                @if (checkFeesChargesNotesRequired() && !checkFeesChargesDisable() && !errorAllowanceCount && allowanceError == 0) {
                                  <p class="mb-0"
                                    >
                                  Notes for stopped Fees is required!</p>
                                }
                                @if (!checkFeesChargesNotesRequired() && !checkFeesChargesDisable() && !errorAllowanceCount && allowanceError == 0 && errorPropertProtectionModel) {
                                  <p class="mb-0"
                                    >
                                  Property Protection fields are required!</p>
                                }
                                <i class="fa fa-caret-down butt_downIcon" aria-hidden="true"></i>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- payment distribution validate popup -->
                <div class="modal fade" bsModal #templatePDConfirm="bs-modal" id="templatePDConfirm" tabindex="-1" role="dialog">
                  <div class="modal-dialog  modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Confirm</h5>
                        <button type="button" class="close" aria-label="Close" (click)="templatePDConfirm.hide()">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body ptb24">
                        <p class="mb-0">Pre-Pay Discount will no longer be applicable. Proceed?</p>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary me-3" (click)="OnConfirmPDAmt('No')">No</button>
                        <button type="button" class="btn btn-primary" (click)="OnConfirmPDAmt('Yes')">Yes</button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Due Breakdown -->
                <div class="modal fade" id="Payment_Breakdown" tabindex="-1" role="dialog">
                  <div class="modal-dialog  modal-dialog-centered modal_90" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">View Breakdown of Dues</h5>
                        <button type="button" class="close" data-bs-dismiss="modal">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body ptb24">
                        <div class="scroll_outer">
                          <div class="scroll_inner">
                            <div class="table_withfilter">
                              <table class="table mb-0 table-ipad tablewrap table_1024">
                                <colgroup>
                                <col width="21.5%">
                                <col width="8%">
                                <col width="8%">
                                <col width="8%">
                                <col width="7%">
                                <col width="7%">
                                <col width="8%">
                                <col width="8%">
                                <col width="7.5%">
                                <col width="7.5%">
                                <col width="9.5%">
                              </colgroup>
                              <thead>
                                <tr>
                                  <th scope="col">Activity</th>
                                  <th scope="col" class="text-center">Deposit</th>
                                  <th scope="col" class="text-center">Rent</th>
                                  <th scope="col" class="text-center">Fees</th>
                                  <th scope="col" class="text-center">Pr. Prot</th>
                                  <th scope="col" class="text-center">Merch.</th>
                                  <th scope="col" class="text-center">Discounts</th>
                                  <th scope="col" class="text-center">Late & Lien</th>
                                  <th scope="col" class="text-center">Tax</th>
                                  <th scope="col" class="text-center">Allowance</th>
                                  <th scope="col" class="text-center">Total</th>
                                </tr>
                              </thead>
                            </table>
                            <div class="paymentdue_table_scroll tablewrap table_1024">
                              <table class="table table-striped table-hover mb-0 float-start">
                                <colgroup>
                                <col width="21.5%">
                                <col width="8%">
                                <col width="8%">
                                <col width="8%">
                                <col width="7%">
                                <col width="7%">
                                <col width="8%">
                                <col width="8%">
                                <col width="7.5%">
                                <col width="7.5%">
                                <col width="9.5%">
                              </colgroup>
                              <tbody>
                                @for (item of ledgerBreakdown; track item) {
                                  <tr>
                                    <td>{{item.Activity}}</td>
                                    <td class="text-center">{{item.Deposit | customCurrency }}</td>
                                    <td class="text-center">{{item.Rent | customCurrency }}</td>
                                    <td class="text-center">{{item.Fee | customCurrency }}</td>
                                    <td class="text-center">{{item.Insurance | customCurrency }}</td>
                                    <td class="text-center">{{item.Merchandise | customCurrency }}</td>
                                    <td class="text-center">{{item.Discount | customCurrency }}</td>
                                    <td class="text-center">{{item.LateLien | customCurrency }}</td>
                                    <td class="text-center">{{item.TotalTax | customCurrency }}</td>
                                    <td class="text-center">{{item.Allowance | customCurrency }}</td>
                                    <td class="text-center">{{item.Total | customCurrency }}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                          <table class="table  table-striped table-hover mb-0 tablewrap table_1024">
                            <colgroup>
                            <col width="21.5%">
                            <col width="8%">
                            <col width="8%">
                            <col width="8%">
                            <col width="7%">
                            <col width="7%">
                            <col width="8%">
                            <col width="8%">
                            <col width="7.5%">
                            <col width="7.5%">
                            <col width="9.5%">
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>Balance</td>
                              <td class="text-center">{{ledgerDueTotal?.Deposit | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Rent | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Fee | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Insurance | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Merchandise | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Discount | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.LateLien | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.TotalTax | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Allowance | customCurrency }}</td>
                              <td class="text-center">{{ledgerDueTotal?.Total | customCurrency }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Back</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Partial Payment Modal -->
          <div class="modal fade" bsModal #PartialPaymentModal="bs-modal" [config]="modalConfig" id="PartialPaymentModal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Partial Payment Amount </h5>
                  <button type="button" class="close" aria-label="Close"
                    (click)="openPartialPayConfirm(templateConfirmPartialPay)">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <form #partialPayForm="ngForm">
                  <div class="modal-body">
                    <div class="row mx-0">
                      <label for="">Amount@if (isRequired('mamtPartialPayment')) {
                        <span class="required">*</span>
                      }</label>
                      <input type="text" class="form-control" [(ngModel)]="amtPartialPayment" (blur)="transformAmount($event)"
                        name="mamtPartialPayment" #mamtPartialPayment="ngModel"
                        onkeypress="if (event.charCode > 31 && (event.charCode < 48 || event.charCode > 57) && event.charCode != 46) { return false;} else { return true;}">
                      </div>
                      <div class="row mx-0 mt-3">
                        <label for="">Note@if (isRequired('mNotesPartialPayment')) {
                          <span class="required">*</span>
                        }</label>
                        <textarea rows="5" class="form-control" [(ngModel)]="NotesPartialPayment" name="mNotesPartialPayment"
                        #mNotesPartialPayment="ngModel"></textarea>
                      </div>
                    </div>
                  </form>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary me-3"
                      (click)="openPartialPayConfirm(templateConfirmPartialPay)">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-primary" [disabled]="partialPayForm.invalid"
                      (click)="SavePartialPaymentReturn()">
                      Generate Letter
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Partial Payment Modal -->

            <ng-template #templateConfirmPartialPay>
              <div class="modal-header">
                <h5 class="modal-title">Confirm</h5>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefConfirm.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body ptb24">
                <p class="mb-0" i18n="@@sure_Cancel">
      Are you sure you want to cancel? Any data Modifications will not be saved
    </p>
              </div>
              <div class="modal-footer">
                <button class="btn btn-outline-primary me-3" type="button" (click)="modalRefConfirm.hide()">No</button>
                <button class="btn btn-primary" type="button" (click)="cancelPartialPayModal()">Yes</button>
              </div>
            </ng-template>

            <app-auto-enrol-insurance-pop-up (PayTerminatedpropertyProtection)="PayTerminatedpropertyProtection()"
              (CancelAutoEnrollPP)="CancelAutoEnrollPP()" (ContinueWithAutoEnrollPP)=" ContinueWithAutoEnrollPP()"
              (CancelAutoEnrollPPWithNoDue)="CancelAutoEnrollPPWithNoDue()" [isShowAutoEnrolledPopuUp]="isShowAutoEnrolledPopuUp"
              [show_PartialPaymentPopup]="show_PartialPaymentPopup" [AutoEnrollPropertyProtection]="AutoEnrollPropertyProtection"
              [AutoEnrolExpiredInsWithNoCharge]="AutoEnrolExpiredInsWithNoCharge" [show_zeroPaymentPopup]="show_zeroPaymentPopup"
            (OnClosePartialPaymentPopUp)="OnClosePartialPaymentPopUp()"></app-auto-enrol-insurance-pop-up>
